import { buildStyleFns, buildStylePropFn } from './buildStyleFns';
export const gridItemStyleFnConfigs = [
    {
        name: 'gridColumnStart',
        properties: ['gridColumnStart'],
        system: 'none',
    },
    {
        name: 'gridColumnEnd',
        properties: ['gridColumnEnd'],
        system: 'none',
    },
    {
        name: 'gridRowStart',
        properties: ['gridRowStart'],
        system: 'none',
    },
    {
        name: 'gridRowEnd',
        properties: ['gridRowEnd'],
        system: 'none',
    },
    {
        name: 'gridColumn',
        properties: ['gridColumn'],
        system: 'none',
    },
    {
        name: 'gridRow',
        properties: ['gridRow'],
        system: 'none',
    },
    {
        name: 'gridArea',
        properties: ['gridArea'],
        system: 'none',
    },
    {
        name: 'justifySelf',
        properties: ['justifySelf'],
        system: 'none',
    },
    {
        name: 'alignSelf',
        properties: ['alignSelf'],
        system: 'none',
    },
    {
        name: 'placeSelf',
        properties: ['placeSelf'],
        system: 'none',
    },
];
export const gridItemStyleFns = buildStyleFns(gridItemStyleFnConfigs);
/**
 * A style prop function that takes component props and returns grid styles.
 * If no `GridItemStyleProps` are found, it returns an empty object.
 *
 * @example
 * ```tsx
 * const GridItemExample = () => (
 *   <Grid.Item gridRowStart="1" justifySelf="center" gridArea="Card">
 *     Hello, Grid Item!
 *   </Grid.Item>
 * );
 * ```
 */
export const gridItem = buildStylePropFn(gridItemStyleFns);
